const activeQuestionIndexReducer = (state = 0, action = {}) => {
    if (action.type === 'SET_ACTIVE_QUESTION_INDEX') {
        return action.payload;
    }
    return state;
}

export default activeQuestionIndexReducer;
